export default __webpack_public_path__ + "static/media/profilepic.5d7526d3.png";